import React from "react";
import { TopBar } from "../components/Navigation";
import { CloudOff } from "lucide-react";
import OfflineGuidesShelf from "../components/OfflineGuidesShelf";

export default function OfflineGuides() {
    return (
        <div data-testid="offline-page">
            <TopBar title="Offline Guides" />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
                <div className="mb-6">
                    <div className="flex items-center gap-3 mb-1">
                        <span className="w-10 h-10 rounded-xl bg-midnight-pine/10 flex items-center justify-center">
                            <CloudOff className="w-5 h-5 text-midnight-pine" />
                        </span>
                        <h1 className="text-2xl sm:text-3xl font-black text-midnight-pine">My Offline Guides</h1>
                    </div>
                    <p className="text-sm text-slate-gray">
                        Guides you've saved to this device. They open with no signal — perfect for the trailhead.
                    </p>
                </div>
                <OfflineGuidesShelf />
            </div>
        </div>
    );
}
